import { render, staticRenderFns } from "./HartlepoolTest.vue?vue&type=template&id=5c435fc6"
import script from "./HartlepoolTest.vue?vue&type=script&lang=js"
export * from "./HartlepoolTest.vue?vue&type=script&lang=js"
import style0 from "./HartlepoolTest.vue?vue&type=style&index=0&id=5c435fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports